import React, { Component } from 'react'
import Navigation from './components/navigation';
import Header from './components/header';
// import Features from './components/features';
// import Testimonials from './components/testimonials';
import About from './components/about';
import Services from './components/services';
import Gallery from './components/gallery';
import SimpleMap from "./components/map";
import Team from './components/Team';
import Contact from './components/contact';
import Footer from './components/footer';
import Cupon from './components/cupon';
import dataCast from './data/data_cast';
import dataCat from './data/data_cat';
// Cookie library
import CookieConsent from "react-cookie-consent";

export class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      lang: 'cast',
      // catData: dataCat,
      // castData: dataCast,
      landingPageData: dataCast,
    }
    this.toggleLang = this.toggleLang.bind(this);
  }
  toggleLang() {
    if(this.state.lang === 'cast'){
      this.setState({
        landingPageData : dataCat,
        lang: 'cat'
      })
    } else if(this.state.lang === 'cat'){
      this.setState({
        landingPageData : dataCast,
        lang: 'cast'
      })
    }
  }

  config_button = () => {
    return (
      <div style ={{width: "10em"}}>
      <div 
        type="button" 
        style={{
          backgroundColor: "#f0f0f0",
          color: "#0000ff",
          fontSize: "13px",
          borderRadius:5,
          height: "3em",
          marginBottom: "1em",
          width: "10em"}}
      >
        {this.state.landingPageData.Cookies.btnAccept}
      </div> 
      <a href="#page-top" className="pdcc-open-modal" style={{color: "#0000ff"}}>
        <div 
          type="button"
          className="pdcc-open-modal"
          style={{
            backgroundColor: "#f0f0f0",
            fontSize: "13px",
            borderRadius:5,
            height: "3em",
            width: "10em"}}
        >{this.state.landingPageData.Cookies.btnConfig}
      </div> 
          </a>
      </div>
    )
  }

  render() {
    return (
      <div style={{}}>
        <Navigation data={this.state.landingPageData.Navigation} onChangeLang={this.toggleLang} lang={this.state.lang}/>
        <Header data={this.state.landingPageData.Header} />
        <Cupon  data={this.state.landingPageData.Cupon}/>
        <About data={this.state.landingPageData.About} />
        <Services data={this.state.landingPageData.Services} />
        {/* <Features data={this.state.landingPageData.Features} /> */}
        <Gallery data={this.state.landingPageData.Gallery} />
        {/* <Testimonials data={this.state.landingPageData.Testimonials} /> */}
        <SimpleMap data={this.state.landingPageData.Map}/>
        <Team data={this.state.landingPageData.Team} />
        <Contact data={this.state.landingPageData.Contact} />
        <Footer />
        
        <CookieConsent
          location="bottom"
          buttonText={this.config_button()}
          cookieName="myCookie"
          expires={150}
          style={{ background: "#2B373B" }}
          buttonStyle={{backgroundColor:"#2B373B"}}
        >
          {this.state.landingPageData.Cookies.main}
          <a href="#page-top">{this.state.landingPageData.Cookies.link}</a>.
          <br/>
          {this.state.landingPageData.Cookies.configure}
        </CookieConsent>
      </div>
    )
  }
}

export default App;
